module.exports = __webpack_public_path__ + "assets/8429bcd29996a5bbcd3b585a8fd53440.png";